import { match } from 'ts-pattern';
import { Plate as V4Plate } from '../__generated/model/versions/v4.js';
export const migrateToV5 = (state)=>{
    return state.map((entity)=>{
        return match(entity).returnType().when(V4Plate.is, (plate)=>({
                ...plate,
                powderCoatingMountingHoleId: null
            })).otherwise((other)=>other);
    });
};

//# sourceMappingURL=v5.js.map